import React from 'react'
import SearchIcon from "@material-ui/icons/Search";
import {
    TablePagination,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Box,
    makeStyles,
    Typography,
    ButtonGroup,
    InputBase,
    withStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    CircularProgress,

} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete'
import { FetchJobSeekerByCoach } from "../apis";
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
    },
    table: {
        marginBottom: "20px"
    },
    tableHeadCell: {
        fontSize: "18px",
    },
    tableRowCell: {
        fontSize: "14px",
        borderBottom: "none",
        lineHeight: "40px",
        align: "left",
    },
    dropdown: {
        position: "absolute",
        top: 28,
        right: 0,
        left: 0,
        zIndex: 1,
        border: "1px solid",
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#f2f2f2",
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto",
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
        fontSize: "14px",
    },
    inputInput: {
        padding: theme.spacing(1.5, 1.5, 1.5, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "40ch",
        },
    },
}));

let headers = ['First Name', 'Last Name', 'Email']
export function SeeClients({ open, onClose, selectedUser }) {

    const classes = useStyles();

    const [coachList, setCoachList] = React.useState([])
    const [loading, setLoading] = React.useState(false)


    const fetchCoach = async () => {
        setLoading(true)
        let data = await FetchJobSeekerByCoach(selectedUser)
        setCoachList([...data.users])
        setLoading(false)
    }

    const StyledTableRow = withStyles((theme) => ({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    React.useEffect(() => {
        fetchCoach()
    }, [])


    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth="100%"

        >
            <DialogTitle id="form-dialog-title">
                <Typography variant="h6">SEE JOB Seekers</Typography>
            </DialogTitle>
            <DialogContent>

                <TableContainer className="mt-10">
                    <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                {headers.map((item, index) => (
                                    <TableCell
                                        key={index}
                                        align="left"
                                        classes={{ root: classes.tableHeadCell }}
                                    >
                                        {item}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {coachList && coachList.length > 0 && coachList.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <TableCell
                                        classes={{
                                            root: classes.tableRowCell,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                    >
                                        {row.firstName}
                                    </TableCell>
                                    <TableCell
                                        classes={{
                                            root: classes.tableRowCell,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                    >
                                        {row.lastName}
                                    </TableCell>
                                    <TableCell
                                        classes={{
                                            root: classes.tableRowCell,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                    >
                                        {row.email}
                                    </TableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    )
}